import styled from 'styled-components'

export const Rect = styled.rect``
